/**
 * Texts for Training page
 */
export const trainingPageText = {
    title: 'Formación - CamAPS FX',
    titleMeta: 'Ofrecemos formación gratuita en línea a los usuarios de CamAPS FX',
    descriptionMeta: 'El Programa de Formación en Diabetes de Cambridge imparte formación certificada gratuita en línea para personas con diabetes de tipo 1, padres y tutores, personal escolar y profesionales sanitarios.',
    keywords: 'entrenamiento camaps, entrenamiento camaps fx,  ',
    localeMeta: 'es_es',
    mainHeader: 'Formación sanitarios',
    mainSubHeader: 'Apoye a las personas que utilizan CamAPS FX con formación dirigida por expertos.',
    gettingStartedHeader: 'Primeros pasos',
    step1Title: '<strong>Paso 1:</strong><br/>Descargue la aplicación',
    step2Title: '<strong>Paso 2:</strong><br/>Cree una cuenta',
    step3Title: '<strong>Paso 3:</strong><br/>Comience la capacitación esencial en la aplicación',
    step4Title: '<strong>Paso 4:</strong><br/>Empareje con su bomba y CGM elegidos (con la aprobación de su equipo de atención médica) o explore la aplicación con <strong>modo virtual</strong>',
    videoSrc: '/video/In-app training loop_1.mp4',
    certifiedTrainingTitle: 'Formación certificada',
    trainingHeader: 'Formación certificada',
    trainingHeader_2: 'Para profesionales sanitarios',
    trainingHeader_3: 'Formación de usuarios',
    trainingHeaderText: 'Formación GRATUITA en línea en CamAPS FX facilitada por el Programa de Formación en Diabetes de Cambridge (CDEP).',
    websiteLink: 'https://www.camdiabtraining.com/account-sign-in.html',
    websiteLinkHeading: 'Formación del CDEP',
    getTrained: 'Fórmese',
    trainingHeaderIat: 'Entrenamiento CamAPS FX',
    trainingHeaderTextIat: 'Completa el entrenamiento esencial dentro de la aplicación antes de usar la app CamAPS FX.',
    trainingSubHeaderOneIat: 'Comenzando',
    trainingSubTextOneIat: 'Descarga la app CamAPS FX. <br>Crea una cuenta para iniciar el entrenamiento.',
    trainingSubHeaderTwoIat: '¿Necesitas ayuda para instalar la app?',
    trainingParaTwoStartIat: 'Visita nuestra',
    trainingParaTwoEndIat: 'sección para obtener orientación.',
    websiteLinkHeadingSupportIat: 'Soporte',
    trainingSubHeaderThreeIat: 'Recursos adicionales',
    animationsYpsoPumpText: 'Animaciones',
    animationsAndText: 'y',
    animationsDanaText: 'Animaciones (bomba Dana)',
    animationsFurtherText: 'Aprende mediante visuales paso a paso.',
    webinarsText: 'Seminarios web',
    webinarsFurtherText: 'Mira sesiones dirigidas por expertos sobre el uso de la app.',
    websiteAnimationsYpsoPumpLink: 'https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm',
    websiteAnimationsDanaLink: 'https://www.camdiabtraining.com/view/25/Dana-insulin-pump-users.htm',
    websiteWebinarsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
};
